import React from 'react'
import { themr } from 'react-css-themr'

import { Drawer } from '@joehua/cms-components'
import MenuWithData, { MenuTheme } from '../Menu'
import Logo from '../Logo'

export interface MobileDrawerTheme {
  root?: string
  logoWrapper?: string
  logo?: string
  menu?: MenuTheme
}

const DumpMobileDrawer = ({
  isOpen,
  onClose,
  theme = {},
}: {
  isOpen: boolean
  onClose: () => void
  theme?: MobileDrawerTheme
}) => (
  <Drawer
    isOpen={isOpen}
    onClose={onClose}
    theme={{
      root:
        'fixed top-0 right-0 w-100 vh-100 bg-white z-999 db dn-l overflow-y-scroll pb4',
    }}
  >
    <div className={theme.logoWrapper}>
      <Logo className="w4" />
    </div>
    <div className={theme.root}>
      <MenuWithData
        data={{ name: 'main', mode: 'inline' }}
        theme={theme.menu}
        onLinkClick={onClose}
      />
    </div>
  </Drawer>
)

export const defaultMobileDrawerTheme: MobileDrawerTheme = {
  root: 'w-100 flex flex-column items-start justify-start',
  logoWrapper: 'pv4 ph4',
  menu: {
    root: 'list pl0 mt5 pv2 tc w-100',
    itemLink: 'pc',
  },
}

const MobileDrawer = themr('MobileDrawer', {}, { composeTheme: 'softly' })(
  DumpMobileDrawer,
)

export default MobileDrawer
